import { GlobalAxios } from "../axios/axios-config";
import { ICalendarConsultationGroupingRegister } from "../models/calendar-consultation-grouping-register";

const CALENDAR_CONSULTATION_GROUPING_REGISTE_ROUTE =
  process.env.REACT_APP_EXTERNAL +
  "/api/v1/CalendarConsultationGroupingRegister/CalendarClassificationExam";

export const calendarConsultationGroupingRegisterList = (params?: any) => {
  return GlobalAxios.get<ICalendarConsultationGroupingRegister[]>(
    CALENDAR_CONSULTATION_GROUPING_REGISTE_ROUTE,
    {
      params: params,
      paramsSerializer: { indexes: null },
    }
  );
};
